import React from "react";
import { useChatbotConfig } from "../../../contexts/chatbot-config";
import { useBottomSheet } from "../../../contexts/bottom-sheet";
import { openCtaLink, trackLinkClick } from "../../../libs/fns";
import { downloadCtaFiles, normalizeSortNumber, type CtaEntry } from "../../../libs/cta";

export function useCtaClick(onFormOpened?: () => void) {
  const { chatbotData, bottomViewData } = useChatbotConfig();
  const { openBottomSheet } = useBottomSheet();

  return React.useCallback(
    (cta: CtaEntry) => {
      if (cta.isLink && cta.link) {
        trackLinkClick(cta.link).catch(() => {});
        openCtaLink(cta.link);
        return;
      }
      if (cta.isForm) {
        const plan = chatbotData?.subscription_info?.basic_plan;
        if (plan?.plan_type === "basic" && plan?.plan_number === 1) return;
        const bottomViewObj = Array.isArray(bottomViewData) ? bottomViewData[0] : bottomViewData;
        const items = bottomViewObj?.data ?? [];
        if (items.length === 0) return;
        const matchedIndex = items.findIndex((entry) => normalizeSortNumber(entry.data_sort) === cta.sortNumber);
        openBottomSheet("CTA", matchedIndex >= 0 ? matchedIndex : 0);
        onFormOpened?.();
        return;
      }
      if (cta.rawDownloadPaths.length > 0) {
        downloadCtaFiles(cta.rawDownloadPaths, chatbotData?.chatbot_S3_URL || "");
      }
    },
    [chatbotData, bottomViewData, openBottomSheet, onFormOpened],
  );
}
